import Features from '@ms/odsp-utilities/lib/features/Features';
import { ABExperiment, ABExpHash } from '@ms/odsp-utilities/lib/logging/ABExperiment';

export const SharingSupportsEmailAuthGuest = { ODB: 469 };
export const PeopleSharingLinks = { ODB: 781 };
export const PeopleSharingLinksExperiment = { ODB: 1217 };

let isPSLExperimentOn = Features.isFeatureEnabled(PeopleSharingLinks) && Features.isFeatureEnabled(SharingSupportsEmailAuthGuest);

if (Features.isFeatureEnabled(PeopleSharingLinksExperiment) && !isPSLExperimentOn
  && Features.isFeatureEnabled(SharingSupportsEmailAuthGuest)) {
  const experiment: ABExperiment = new ABExperiment({
    name: "PeopleSharingLinks",
    startDate: "02/12/2019",
    version: ABExpHash.v2
  });

  isPSLExperimentOn = experiment.IsExperimentOn();
}

export default isPSLExperimentOn;
